// @ts-ignore
import { defineNuxtPlugin } from '#app'
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

export default defineNuxtPlugin((nuxtApp: any) => {
    nuxtApp.vueApp.component('v-swiper', Swiper)
    nuxtApp.vueApp.component('v-swiper-slide', SwiperSlide)
})
